import React from "react";

const LoadingEqualizer: React.FC = () => {
  return (
    <div className="flex items-center justify-center gap-1 p-4">
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className="w-1 bg-gray-300 rounded-full animate-loading-bar"
          style={{
            height: "16px",
            animationDelay: `${i * 0.1}s`,
          }}
        ></div>
      ))}
    </div>
  );
};

export default LoadingEqualizer;
